import { AfterViewInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({ selector: '[appScrollFade]' })
export class ScrollFadeDirective implements AfterViewInit {
    constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

    ngAfterViewInit(): void {
        setTimeout(() => this.update(), 0);
    }

    @HostListener('scroll')
    onScroll(): void {
        this.update();
    }

    private update(): void {
        const el = this.el.nativeElement;
        const parent = el.parentElement;
        if (!parent) return;

        const { scrollTop, scrollHeight, clientHeight } = el;
        const hasOverflow = scrollHeight > clientHeight + 2;

        this.toggle(parent, 'scroll-top', !hasOverflow || scrollTop < 5);
        this.toggle(parent, 'scroll-bottom', !hasOverflow || scrollTop + clientHeight >= scrollHeight - 5);
    }

    private toggle(el: HTMLElement, cls: string, add: boolean): void {
        add ? this.renderer.addClass(el, cls) : this.renderer.removeClass(el, cls);
    }
}
